import React from 'react'
import classNames from 'classnames'

import './load-more-button.scss'

const LoadMoreButton = (props) => {
  const { button, onClick, isComment, isPost, hoveredPostButton } = props

  const buttonClasses = classNames({
    'load-more-comments': isComment,
    'load-more-posts': isPost,
    'load-more-posts--hovered': hoveredPostButton,
  })

  return (
    <div className={buttonClasses} onClick={onClick}>
      {button}
    </div>
  )
}

export default LoadMoreButton
